import { useState } from "react";

import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { apiClient, getErrorMessage } from "@/features/shared";
import { UserInformationDialog } from "@/features/users";
import { UserForm } from "@/features/users/user-form/user-form";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreateUser = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [addedUser, setAddedUser] = useState(null);

  const handleSubmit = async ({
    name,
    username,
    email,
    contactNumber,
    roleId,
    platform,
    status,
  }) => {
    try {
      const {
        data: { data },
      } = await apiClient.post("users", {
        name,
        username,
        email,
        contactNumber,
        roleId,
        platform,
        status,
      });

      setAddedUser({
        name,
        username,
        ...data,
      });
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal membuat pengguna"));
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Tambah Pengguna"
      breadcrumbs={[
        { title: "Pengguna", path: "/setting/users" },
        { title: "Tambah" },
      ]}
    >
      <UserForm
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
      {addedUser && (
        <UserInformationDialog
          open
          user={addedUser}
          title="User berhasil ditambahkan"
          onClose={() => {
            setAddedUser(null);
            navigate(-1);
          }}
        />
      )}
    </PageContainer>
  );
};
